import { Box, Divider, Heading, Icon, Text } from '@medely/ui-kit';
import { JobDetailsListItem } from '@mp/components/jobs';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import React from 'react';
import { AssignmentForAssignmentDetailsGql } from '../../graphql';

export const AssignmentFacility = ({
  assignment: inputAssignment,
  smallIcon,
}: {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
  smallIcon?: boolean;
}) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  return (
    <>
      <Divider />
      <Box testId="assignment-facility" mt={2}>
        <Heading size="s" color="text.primary" testId="assignment-facility-title">
          About the facility
        </Heading>
        {assignment?.clinical_contact && (
          <Box mt={3} testId="assignment-facility-primary-contact">
            <JobDetailsListItem
              title="Primary contact"
              icon={
                <Icon
                  name="light-phone"
                  iconSize={smallIcon ? '14px' : '20px'}
                  color="text.primary"
                  variant="custom"
                />
              }
            >
              <Text size="m" color="text.primary" testId="assignment-facility-primary-contact-info">
                {assignment?.clinical_contact?.first_name} {assignment?.clinical_contact?.last_name}
              </Text>
            </JobDetailsListItem>
          </Box>
        )}
      </Box>
    </>
  );
};
